export default {"src":"/_next/static/media/unread.6cb9c52a.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};